import * as React from "react";

export default function Message() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M2.5 22a1 1 0 0 1-.95-1.32l1.77-5.31A9.5 9.5 0 0 1 7.75 3 9.62 9.62 0 0 1 12 2h.5a9.47 9.47 0 0 1 9 9v.55A9.51 9.51 0 0 1 12 21a9.09 9.09 0 0 1-3.87-.82L2.81 22a1.12 1.12 0 0 1-.31 0ZM12 4a7.35 7.35 0 0 0-3.33.79 7.49 7.49 0 0 0-3 2.77A7.41 7.41 0 0 0 4.5 11.5a7.34 7.34 0 0 0 .79 3.35 1 1 0 0 1 .06.77l-1.27 3.8 3.8-1.27a1 1 0 0 1 .77.06A7.11 7.11 0 0 0 12 19a7.48 7.48 0 0 0 6.71-4.15 7.35 7.35 0 0 0 .8-3.35V11a7.49 7.49 0 0 0-7.06-7H12Z" />
    </svg>
  );
}
